import { defineComponent as _defineComponent } from 'vue';
import ApplicationLogoWhite from '@/Components/Layout/ApplicationLogoWhite.vue';
import ApplicationLogoH from '@/Components/Layout/ApplicationLogoH.vue';
import UserMenu from '@/Components/UserMenu.vue';
import { Link } from '@inertiajs/inertia-vue3';
import SpinnerFullscreen from '../Components/SpinnerFullscreen.vue';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Authenticated',
    setup(__props, { expose }) {
        expose();
        const __returned__ = { ApplicationLogoWhite, ApplicationLogoH, UserMenu, get Link() { return Link; }, SpinnerFullscreen, get Toast() { return Toast; }, get ConfirmDialog() { return ConfirmDialog; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
